// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* head bar text color */
@font-face {
  color: #000;
  font-family: Roboto-Black;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Bold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-SemiBold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Light;
  src: url("/assets/fonts/Roboto-Light.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Medium;
  src: url("/assets/fonts/Roboto-Medium.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Regular;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Thin;
  src: url("/assets/fonts/Roboto-Thin.ttf") format("truetype");
}
:host .cs-table-default {
  width: 100%;
}
:host .cs-table-default tr:nth-child(odd) td {
  background-color: #f0f4f7;
}
:host .cs-table-default .thead td {
  background-color: #f0f4f7;
  color: #000;
  padding: 0.6rem 1em;
  border-right: 1px solid #dfe3eb;
  border-bottom: 1px solid #dfe3eb;
}
:host .cs-table-default .thead td:last-child {
  border-right: none;
}
:host .cs-table-default .tv-head td {
  padding: 0.6rem 1em;
  border-right: 1px solid #dfe3eb;
  border-bottom: 1px solid #dfe3eb;
  color: #4b5b70;
}
:host .cs-table-default .tv-head td:last-child {
  border-right: none;
}
:host .cs-table-default .tv-head td:first-child {
  color: #000;
}
:host .cs-table-default .trow td {
  box-sizing: border-box;
  flex-grow: 1;
  padding: 0.6em 1em;
  list-style-type: none;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-bottom: 1px solid #dfe3eb;
  align-items: center;
  border-right: 1px solid #dfe3eb;
}
:host .cs-table-default .trow td:last-child {
  border-right: none;
}
:host .cs-table-default.bg-white tr:nth-child(odd) td {
  background-color: #fff;
}
:host .td-footer {
  color: #000;
  padding: 0.6rem 1em;
}
:host .font-bold td {
  font-weight: Roboto-Medium;
}
:host .cs-table-default {
  border: 1px solid #dfe3eb;
  margin: 1rem 0 2rem;
}
:host .width-160 {
  width: 160px;
}
:host .width-130 {
  width: 130px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
